import React, { Fragment, useState } from 'react'
import styled from 'styled-components'
import { number, func, object, bool } from 'prop-types'
import Text from './Text'
import {
  WHITE,
  VERMILION,
  METAL,
  TEXT_MEDIUM,
  LIGHT_GREY,
} from '../../constants'
import { SECONDARY_BUTTON } from '../../constants/buttonThemes'
import { structuredTableShape, structuredDataShape } from '../../types'
import '@fontsource/dm-sans' // Defaults to weight 400
import { useTranslation } from 'react-i18next'
import Button from './Button'

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 40px;
`
// const Wrapper = styled.div`
//   display: flex;
//   margin: auto 0 0;
// `
const ButtonWrapper = styled.div`
  transform: ${({ isPrev }) => (isPrev ? 'rotate(-135deg)' : 'rotate(45deg)')};
  padding: 9px;
  box-shadow: 3px -3px 0 0 ${VERMILION};
  margin: 14px;
  height: fit-content;
`

const StyledButton = styled.button`
  border: none;
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 8px;
  ${({ disabled }) => !disabled && 'cursor: pointer'};
  outline: none;
`

const PagesNumber = styled.div`
  display: inline-block;
  position: relative;
  top: 13px;
`
const FilterLabel = styled.label`
  padding-left: 10px;
  align-content: center;
`
const Spacer = styled.div`
  display: flex;
  flex-grow: 1;
`
const StyledInput = styled.input`
  type="search";
  width: 30%;
  display: inline-block;
  font-family: 'DM Sans';
  color: ${METAL};
  font-size: ${TEXT_MEDIUM};
  margin: 0;
  background-color: ${WHITE};
  border: 1px solid ${LIGHT_GREY};
  transition: all 0.3s;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 5px;
  padding-left: 10px;
  margin-right: 10px;
`

const SearchableTableBar = ({
  page,
  pageTotal,
  selectNextPage,
  selectPreviousPage,
  searchValue,
  onSearchChange,
  setFiltering,
  filterQuery,
}) => {
  const { t } = useTranslation()

  const searchWithEllipses = t('search') + '...'

  const formatDate = dateString => {
    var splitDate = dateString.split('-')
    return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`
  }

  const FilterMessage = () => {
    let filterArray = []
    if (!(filterQuery.scoreFrom == 0 && filterQuery.scoreTo == 100)) {
      filterArray.push(
        `Score Range: ${filterQuery.scoreFrom}% - ${filterQuery.scoreTo}%`
      )
    }
    if (filterQuery.fromDate != '') {
      var date = new Date()
      filterArray.push(`From: ${formatDate(filterQuery.fromDate)}`)
    }
    if (filterQuery.toDate != '') {
      filterArray.push(`To: ${formatDate(filterQuery.toDate)}`)
    }
    if (
      filterQuery.successFilter ||
      filterQuery.failFilter ||
      filterQuery.progressFilter ||
      filterQuery.recalculatingFilter ||
      filterQuery.recalculationFailedFilter
    ) {
      let statusArray = []
      if (filterQuery.successFilter) {
        statusArray.push(t('audit_success'))
      }
      if (filterQuery.failFilter) {
        statusArray.push(t('audit_failed'))
      }
      if (filterQuery.progressFilter) {
        statusArray.push(t('audit_progress'))
      }
      if (filterQuery.recalculatingFilter) {
        statusArray.push(t('audit_recalculating'))
      }
      if (filterQuery.recalculationFailedFilter) {
        statusArray.push(t('audit_recalculationFailed'))
      }
      filterArray.push(`Status: ${statusArray.join(', ')}`)
    }

    return <FilterLabel>{filterArray.join(', ')}</FilterLabel>
  }

  return (
    <Fragment>
      <Wrapper>
        <StyledInput
          placeholder={searchWithEllipses}
          onChange={onSearchChange}
          value={searchValue}
        />
        <Button theme={SECONDARY_BUTTON} onClick={setFiltering}>
          {t('filtering')}
        </Button>
        <FilterMessage />
        <Spacer />
        <ButtonWrapper isPrev>
          <StyledButton
            onClick={selectPreviousPage}
            disabled={page === 0 || page === null}
          />
        </ButtonWrapper>
        <PagesNumber>
          <Text bold>{`${page + 1} of ${pageTotal} `}</Text>
        </PagesNumber>
        <ButtonWrapper>
          <StyledButton
            onClick={selectNextPage}
            disabled={page + 1 === pageTotal || pageTotal === null}
          />
        </ButtonWrapper>
      </Wrapper>
    </Fragment>
  )
}

SearchableTableBar.propTypes = {
  columns: structuredTableShape,
  data: structuredDataShape,
  expanded: object,
  getTrProps: func,
  isUsersTable: bool,
  onExpandedChange: func,
  page: number,
  pageSize: number.isRequired,
  pageTotal: number,
  selectNextPage: func.isRequired,
  selectPreviousPage: func.isRequired,
  SubComponent: func,
}
export default SearchableTableBar
